import { telemetry, CustomDimensions } from "../telemetry";
const uuid = require("uuid");

/**
 * Contract for a Lap used by the Timer.
 *
 * @interface Lap
 */
export interface Lap {
  startInMs: number;
  endInMs?: number;
}

/*
 * Times an action which returns a Promise.
 *
 * @export
 * @class Timer
 */
export class Timer {
  /**
   * Time the given action.
   * Action should be a function returning a Promise.
   */
  public static startLap(): Lap {
    return { startInMs: new Date().getTime() };
  }

  public static endLapAndTrack(lap: Lap, telemetryProps: CustomDimensions): void {
    lap.endInMs = new Date().getTime();
    telemetry.trackAjax(telemetryProps.id || uuid.v4(), lap.endInMs - lap.startInMs, telemetryProps);
  }
}
